import { COUNTRY } from './enums';

export const USA_COUNTRY_OPTION = { id: '1', name: COUNTRY.USA };

export const navigationHeight = 51;

export const MSA_AGREEMENT_LINK =
  'https://resurety.com/master-subscription-agreement';

/**
 * Maximum fixed price the offer and bid forms accept. The forms apply it to every product
 * type; the backend applies it to $/MWh prices only. See the bid-price wiki page.
 */
export const MAX_FIXED_PRICE = 1000;

/** External link to the platform fee schedule document. */
export const FEE_SCHEDULE_URL =
  'https://resurety.com/?resurety-regulatory-document=335';
